import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useProfile } from '../../contexts/ProfileContext';
import { useTenant } from '../../contexts/TenantContext';

export function usePortalPermissions() {
  const { authState } = useAuth();
  const { profile, profileState } = useProfile();
  const { tenantId, tenantState, error: tenantError } = useTenant();
  const location = useLocation();

  const pathname = location.pathname || '';
  const isPortalRoute = pathname.startsWith('/portal');

  const isSuperadmin = profile?.global_role === 'superadmin';

  // Employee = any authenticated user on /portal with a resolved tenant,
  // superadmin explicitly excluded from employee UX.
  const isEmployee = isPortalRoute && !!tenantId && !isSuperadmin;

  // Global loading: wait for auth to load, then wait for tenant to load
  const authLoading = authState === 'loading';
  const profileLoading = profileState === 'loading' || profileState === 'idle';
  const tenantLoading = tenantState === 'loading';
  const loading = authLoading || profileLoading || tenantLoading;

  return {
    loading,
    authLoadState: authState,
    isPortalRoute,
    isEmployee,
    isSuperadmin,
    profile,
    tenantId,
    tenantLoadState: tenantState,
    tenantError,
  };
}
